import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";

const useGetGestaoAssinaturaDigitalDocumentoPaginada = (params: any) => {
  return useFetch({
    url: api.groupsign.gestaoAssinaturaDigitalDocumento,
    key: ["gestao-assinatura-digital-documento", params],
    params,
  });
};

export default useGetGestaoAssinaturaDigitalDocumentoPaginada;
